<template>
	<div class="supplies-card" @click="goDetail">
		<div class="imgbox">
			<img :src="imageSrc" :alt="item.name" @error="onImageError" />
			<span v-if="hasDiscount && !isInquiry" class="discount-badge">{{ item.maxDiscountPercent }}%</span>
		</div>
		<div class="info">
			<span class="brand-name">{{ item.brandName }}</span>
			<b class="catalog-name">{{ item.name }}</b>
			<p class="category-name">{{ item.categoryName }}</p>
			<div class="price">
				<span v-if="isInquiry" class="inquiry-pill">견적 문의</span>
				<template v-else>
					<span v-if="hasDiscount" class="origin">{{ CommaNum(item.minUnitPrice) }}원</span>
					<h6>
						{{ CommaNum(item.minSellingPrice) }}원<span v-if="item.productCount > 1">~</span>
					</h6>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
import mixin from '@/mixins'
import PageName from '@/utils/define/PageName'

export default {
	name: 'SuppliesCard',
	mixins: [mixin],
	props: {
		item: {
			type: Object,
			default: () => ({}),
		},
	},
	data() {
		return {
			imageFailed: false,
		}
	},
	computed: {
		hasDiscount() {
			return this.item.maxDiscountPercent > 0
		},
		// 가격이 0원인 상품은 가격 대신 '견적 문의'로 표시
		isInquiry() {
			return !(this.item.minSellingPrice > 0)
		},
		imageSrc() {
			if (this.imageFailed) return require('@/assets/svg/empty_product.svg')
			return this.item.imageUrl || this.item.brandImage || require('@/assets/svg/empty_product.svg')
		},
	},
	methods: {
		onImageError() {
			this.imageFailed = true
		},
		goDetail() {
			// 상세는 기존 스토어 상품 상세로 이동
			this.$router.push({
				name: PageName.ProductSale,
				params: {
					category: 'list',
					id: this.item.catalogId,
				},
			})
		},
	},
}
</script>

<style lang="scss" scoped>
.supplies-card {
	display: flex;
	flex-direction: column;
	background: #fff;
	border: 1px solid #e5e9ee;
	border-radius: 8px;
	overflow: hidden;
	cursor: pointer;
	transition: all ease-in-out 0.2s;
	&:hover {
		border-color: #6aa7d8;
		box-shadow: 0 4px 14px rgba(40, 90, 140, 0.12);
		transform: translateY(-2px);
	}
	.imgbox {
		position: relative;
		width: 100%;
		padding-top: 100%;
		background: #f6f8fa;
		img {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			object-fit: contain;
		}
		.discount-badge {
			position: absolute;
			top: 10px;
			left: 10px;
			padding: 2px 8px;
			border-radius: 12px;
			background: #e5484d;
			color: #fff;
			font-size: 0.75rem;
			font-weight: 700;
		}
	}
	.info {
		display: flex;
		flex-direction: column;
		gap: 4px;
		padding: 12px 14px 16px;
		.brand-name {
			font-size: 0.75rem;
			color: #6b7785;
		}
		.catalog-name {
			font-size: 0.9rem;
			line-height: 1.35;
			color: #1f2933;
			display: -webkit-box;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
			overflow: hidden;
			min-height: 2.4em;
		}
		.category-name {
			margin: 0;
			font-size: 0.75rem;
			color: #8a94a0;
		}
		.price {
			margin-top: 6px;
			.origin {
				display: block;
				font-size: 0.75rem;
				color: #9aa4af;
				text-decoration: line-through;
			}
			h6 {
				margin: 0;
				font-size: 1.05rem;
				font-weight: 700;
				color: #1f2933;
			}
			/* 0원: 견적 문의 (버튼 모양) */
			.inquiry-pill {
				display: inline-flex;
				align-items: center;
				gap: 7px;
				height: 32px;
				padding: 0 16px;
				border: 1px solid #bcd6ee;
				border-radius: 16px;
				background: #eaf3fb;
				color: #1d4f80;
				font-size: 0.9rem;
				font-weight: 800;
				line-height: 1;

				&:before {
					content: "";
					width: 15px;
					height: 15px;
					background-color: currentColor;
					-webkit-mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Crect x='3' y='5' width='18' height='14' rx='2'/%3E%3Cpath d='M3 7l9 6 9-6'/%3E%3C/svg%3E")
						center / contain no-repeat;
					mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Crect x='3' y='5' width='18' height='14' rx='2'/%3E%3Cpath d='M3 7l9 6 9-6'/%3E%3C/svg%3E")
						center / contain no-repeat;
				}
			}
		}
	}
}
</style>
